import styled from 'styled-components';

export const Container = styled.main`
  flex: 1;
  display: flex;

  max-width: 100%;
  min-width: 0;
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  min-width: 0;
`;

export const Content = styled.div`
  flex: 1;
`;
